import Link from "next/link";
import { ComponentProps, ForwardedRef, forwardRef } from "react";

export const ForwardRefNextLink = forwardRef(
  ({ href, ...rest }: ComponentProps<typeof Link>, ref: ForwardedRef<HTMLAnchorElement>) => {
    return <Link href={href} passHref {...rest} ref={ref} />;
  }
);
ForwardRefNextLink.displayName = "ForwardRefNextLink";
